// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { Association, AssociationSchema } from 'api/gen/Association';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { BasicRole, BasicRoleSchema } from 'api/gen/BasicRole';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Date, DateSchema } from 'api/gen/Date';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PositiveInteger, PositiveIntegerSchema } from 'api/gen/PositiveInteger';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { User, UserSchema } from 'api/gen/User';

const requiredPart = t.interface({
  approvedFrom: DateSchema,
  approvedTo: t.union([DateSchema, t.null]),
  association: AssociationSchema,
  role: BasicRoleSchema,
  user: UserSchema,
  userProfileAssociationRoleId: PositiveIntegerSchema,
});

export const UserProfileAssociationRoleSchema = excess(requiredPart);

export interface UserProfileAssociationRole extends t.TypeOf<typeof UserProfileAssociationRoleSchema> {}
